import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Header, Footer, Seo } from "../../components";
import { NotFoundWarningIcon } from "./NotFoundWarningIcon";
import { NOT_FOUND_CONTENT } from "./notFoundConfig";
import "./NotFound.css";

export const NotFound = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate("/");
  };

  const title = `${NOT_FOUND_CONTENT.titleLine1}\n${NOT_FOUND_CONTENT.titleLine2}`;

  return (
    <div className="not-found-shell">
      {/* 404는 색인하지 않되, 복구 링크는 따라갈 수 있도록 noindex, follow.
          canonical/Article/Course 등 구조화 데이터는 출력하지 않는다. */}
      <Seo
        title="페이지를 찾을 수 없습니다 | 희망과학 심리상담센터"
        robots="noindex, follow"
      />
      <Header variant="light" />
      <main className="not-found-page">
        <div className="not-found-page__inner">
          <NotFoundWarningIcon />
          <h1 className="not-found-page__title">{title}</h1>
          <p className="not-found-page__description">
            {NOT_FOUND_CONTENT.description}
          </p>
          <button
            type="button"
            className="not-found-page__back-btn"
            onClick={handleGoBack}
          >
            {NOT_FOUND_CONTENT.backButtonLabel}
          </button>
          <nav className="not-found-page__links" aria-label="추천 이동 경로">
            <Link to="/">메인페이지 이동</Link>
            <Link to="/courses">교육과정 보기</Link>
            <Link to="/faq">자주 묻는 질문 보기</Link>
          </nav>
        </div>
      </main>
      <Footer variant="light" />
    </div>
  );
};
